import React from 'react';
import { Image } from 'react-konva';
import {
  // isMobilePhone,
  // isMobileTablet,
} from '../../library/calc';


const adjustTop = 6;
const adjustLeft = 30;


export class NodeSpinner extends React.Component {

  render() {

    let {
      left,
      top,
    } = this.props;

    left += adjustLeft;
    top += adjustTop;

    return (
        <Image
          image={this.props.nodeSpinnerGif}
          width={12}
          height={12}
          x={left}
          y={top}
        />
    );
  }
}



